import { commonDictionary } from '@shared/i18n';

export const common = {
  COMMON: commonDictionary,
};

export const commonNamespaces = ['COMMON'];
